import Icon from '@/components/ui/AppIcon';

interface SecurityFeature {
  icon: string;
  title: string;
  description: string;
}

const securityFeatures: SecurityFeature[] = [
  {
    icon: 'ShieldCheckIcon',
    title: 'Data Encryption',
    description: 'End-to-end encryption protects your personal information and listening history'
  },
  {
    icon: 'LockClosedIcon',
    title: 'Secure Payments',
    description: 'PCI-DSS compliant payment processing with multiple secure payment options'
  },
  {
    icon: 'EyeSlashIcon',
    title: 'Privacy First',
    description: 'We never share your data with third parties without explicit consent'
  },
  {
    icon: 'DocumentCheckIcon',
    title: 'GDPR Compliant',
    description: 'Full compliance with international data protection regulations'
  }
];

export default function SecurityPrivacy() {
  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 to-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-success/10 text-success px-4 py-2 rounded-full mb-6">
            <Icon name="ShieldCheckIcon" size={20} variant="solid" />
            <span className="text-sm font-semibold">Trusted by 5 Million+ Users</span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-text-primary mb-4">
            Your Security &<br />
            <span className="text-primary">Privacy Matter</span>
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            We take your data security seriously with industry-leading protection measures
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {securityFeatures.map((feature, index) => (
            <div
              key={index}
              className="text-center"
            >
              <div className="w-20 h-20 bg-primary/10 text-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Icon name={feature.icon as any} size={36} variant="solid" />
              </div>
              <h3 className="text-xl font-heading font-bold text-text-primary mb-2">
                {feature.title}
              </h3>
              <p className="text-text-secondary">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-card p-8 rounded-2xl border border-border max-w-4xl mx-auto">
          <div className="flex items-start space-x-4">
            <Icon name="InformationCircleIcon" size={24} className="text-primary flex-shrink-0 mt-1" />
            <div>
              <h4 className="text-lg font-heading font-bold text-text-primary mb-3">
                What We Collect & Why
              </h4>
              <ul className="space-y-2 text-text-secondary">
                <li className="flex items-start space-x-2">
                  <Icon name="CheckCircleIcon" size={16} variant="solid" className="text-success mt-1 flex-shrink-0" />
                  <span>Basic account information for personalized recommendations</span>
                </li>
                <li className="flex items-start space-x-2">
                  <Icon name="CheckCircleIcon" size={16} variant="solid" className="text-success mt-1 flex-shrink-0" />
                  <span>Listening history to improve content suggestions</span>
                </li>
                <li className="flex items-start space-x-2">
                  <Icon name="CheckCircleIcon" size={16} variant="solid" className="text-success mt-1 flex-shrink-0" />
                  <span>Device information for optimal app performance</span>
                </li>
                <li className="flex items-start space-x-2">
                  <Icon name="CheckCircleIcon" size={16} variant="solid" className="text-success mt-1 flex-shrink-0" />
                  <span>Payment details (securely processed by certified partners)</span>
                </li>
              </ul>
              <div className="mt-4 pt-4 border-t border-border">
                <p className="text-sm text-text-secondary">
                  Read our complete{' '}
                  <a href="#" className="text-primary hover:underline font-semibold">
                    Privacy Policy
                  </a>
                  {' '}and{' '}
                  <a href="#" className="text-primary hover:underline font-semibold">
                    Terms of Service
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}